import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import CreativeFileUploadRoute from './Routes/CreativeFileUploadRoute'
import ThirdPartyCreativesTagsRoute from './Routes/ThirdPartyCreativesTagsRoute'
import AdCreativeTypeStep from './Steps/AdCreativeTypeStep'
import useStepFormRoutes from '../../../../../hooks/formHooks/useStepFormRoutes'

import { clearCreateAdsBatch } from '../../../../../modules/actions/ads'
import {
  createAdsBatchIsLoadingSelector,
  createAdsBatchErrorSelector,
  createAdsBatchWasCreatedSelector,
  createAdsBatchSelector
} from '../../../../../modules/selectors/ads'

import { AD_DV360_CREATE } from '../../../../../constants/forms'

import { CAMPAIGN_MANAGER_THIRD_PARTY_CREATIVE_TAGS, CREATIVE_FILE_UPLOAD } from './fields'

const AdDv360CreateForm = ({ handleAdsExceptions, formProgressItems, onSuccessSubmit, lineItemType }) => {
  const dispatch = useDispatch()

  const createdAdsData = useSelector(createAdsBatchSelector)
  const adWasCreated = useSelector(createAdsBatchWasCreatedSelector)

  const manageStepFormRoutes = useStepFormRoutes({ initialRoute: CREATIVE_FILE_UPLOAD })

  const exceptions = createdAdsData.exceptions
  const hasExceptions = exceptions && exceptions.length > 0

  const clearCreateAdHandler = useCallback(() => {
    dispatch(clearCreateAdsBatch())
  }, [dispatch])

  const getSelectedRoute = useCallback(
    props => {
      switch (manageStepFormRoutes.selectedRoute) {
        case CAMPAIGN_MANAGER_THIRD_PARTY_CREATIVE_TAGS:
          return <ThirdPartyCreativesTagsRoute {...props} />
        case CREATIVE_FILE_UPLOAD:
        default:
          return <CreativeFileUploadRoute {...props} />
      }
    },
    [manageStepFormRoutes.selectedRoute]
  )

  useEffect(() => {
    if (adWasCreated && hasExceptions) {
      handleAdsExceptions(exceptions)
    }
  }, [adWasCreated, hasExceptions, handleAdsExceptions, exceptions])

  return getSelectedRoute({
    formName: AD_DV360_CREATE,
    successSubmit: adWasCreated,
    errorSelector: createAdsBatchErrorSelector,
    isLoadingSelector: createAdsBatchIsLoadingSelector,
    // this allow to clearCreateAd on error
    clearSubmitHandler: clearCreateAdHandler,
    formProgressItems,
    onSuccessSubmit,
    lineItemType,
    FormRouteSelector: <AdCreativeTypeStep manageStepFormRoutes={manageStepFormRoutes} />
  })
}

AdDv360CreateForm.propTypes = {
  handleAdsExceptions: PropTypes.func.isRequired,
  formProgressItems: PropTypes.arrayOf(PropTypes.object),
  onSuccessSubmit: PropTypes.func
}

export default AdDv360CreateForm
